import React, { useState, useEffect } from "react";
import { Header } from '../../Components/Layout/Header.jsx'
import { ObavijestiCasino } from '../../Components/Layout/ObavijestiCasino.jsx'
import { MetaTags } from '../../Components/Layout/MetaTags.jsx'
import CasinoSuperskokBanner from "../../Components/Casino/CasinoSuperskok/CasinoSuperskokBanner.jsx";
import CasinoSuperskokInfo from "../../Components/Casino/CasinoSuperskok/CasinoSuperkokInfo.jsx";
import CasinoSuperSkokPageContent from "../../Components/Casino/CasinoSuperskok/CasinoSuperSkokPageContent.jsx";
import { GameDetails } from '../../Components/Game/GameDetails.jsx'
import { useParams } from "react-router-dom";

export default function BonusesCasinoSuperskok(props) {

    const [state, setState] = useState({
        info: null,
        results: null,
        resultsLoaded: false,
        rewardsTab: false,
        gamesTab: false,
        hasScrolledIntoView: false,
        finalResults: [],
        activePlayers: 0,
        isFinished: null,
        igracJeLogiran: null,
        player: null,
        games: [],
        gameCategories: [],
        isCustomPromotion: false,
    });
    const [tabs, setTabs] = useState(['SuperSprint', 'SuperSkok']);
    const [selectedTab, setSelectedTab] = useState('SuperSprint');
    const { kampanja } = useParams();

    useEffect(() => {
        window.scrollTo(0, 0);
        props.showMenuFn(false);
        casino.utils.createPageGoogleTagManagerEvent('Bonusi', 'Superskok Utrka', 'casino', props.user);
        getData();

        return (() => {
            props.showLoadingFn(false);
        })
    }, []);

    useEffect(() => {
        const hash = window.location.hash;

        if (!state.hasScrolledToRewards && state.resultsLoaded && (hash === "#rewards" || hash === "#games")) {
            if (hash === "#rewards") {
                setState(prev => ({ ...prev, rewardsTab: true }));
            } else if (hash === "#games") {
                setState(prev => ({ ...prev, gamesTab: true }));
            }

            const el = document.querySelector(hash);

            if (el) {
                setTimeout(() => {
                    el.scrollIntoView({ behavior: "smooth" });
                    setState(prev => ({ ...prev, hasScrolledToRewards: true }));
                }, 300);
            }
        }
    }, [state.resultsLoaded, state.hasScrolledToRewards]);

    function getData() {
        props.showLoadingFn(true);
        var promises = Promise.all([
            casino.repos.gameRepo.list().then(props.unpackGamesListFn),
            casino.repos.categoryRepo.list().then(props.saveCategoriesFn),
            casino.repos.casinoSuperskokRepo.rezultati(kampanja ? kampanja : "1")]);
        var dataPromises = casino.utils.makeCancelablePromise(promises);
        dataPromises.promise.then(setData, function (reason) { });
    }

    function setData(data) {

        props.showLoadingFn(false);
        var [games, gameCategories, res] = data;
        setState({
            ...state,
            results: res.results,
            info: res.info,
            resultsLoaded: true,
            finalResults: res.finalResults,
            activePlayers: res.activePlayers,
            isFinished: new Date().getTime() > new Date(res.info.aktivnoDo).getTime(),
            games: games,
            gameCategories: gameCategories.items,
            isCustomPromotion: kampanja == "super-travanj"
        });
    }

    function goToTab(tab) {
        setSelectedTab(tab);
    }

    useEffect(() => {
        if (props.user != null && state.results != null) {
            let player = state.results.find(it => it.nickname == props.user.nadimak);
            setState({ ...state, player: player, igracJeLogiran: props.user });
        };
    }, [props.user, state.results]);


    return (
        <div>
            <MetaTags title="Promocije - SuperSport CASINO" description="Superskok Utrka u SuperSport CASINU!" />
            <Header key="header" {...props}></Header>
            <CasinoSuperskokBanner info={state.info} kampanja={kampanja} />
            <div className='white-background'>
                <div id="page-wrapper" className="max-width-70 min-height margin-center no-padding-on-mobile">
                    {state.isCustomPromotion && <CasinoSuperskokInfo brands={props.brands} {...props} {...state} kampanja={kampanja + "-before"} />}
                    {state.isCustomPromotion &&
                        <div className="segment v2" id="tabs">
                            {tabs && tabs.map((tab) =>
                                <button key={tab} onClick={() => goToTab(tab)} className={'segment--btn' + (selectedTab === tab ? ' selected' : '')}><span>{tab}</span></button>
                            )}
                        </div>
                    }
                    {state.isCustomPromotion && selectedTab == "SuperSprint" && <CasinoSuperskokInfo brands={props.brands} {...props} {...state} kampanja={kampanja + "-sprint"} />}
                    {state.isCustomPromotion && selectedTab == "SuperSkok" && <CasinoSuperSkokPageContent {...props} {...state} kampanja={kampanja + "-inTab"} />}
                    {!state.isCustomPromotion && state.info && <CasinoSuperSkokPageContent {...props} {...state} kampanja={kampanja} />}
                </div>
            </div>
            {kampanja && <GameDetails loadGames={true} {...props} {...state} routePrefix={"/promotions/casino-superskok/" + kampanja}></GameDetails>}
            <ObavijestiCasino {...props}></ObavijestiCasino>
        </div>
    )
}